import React, { useState } from 'react';
import { Tooltip } from '@onward-delivery/design';
import { Copy, Icon, Mail, Phone } from '@onward-delivery/design/icons';
import { toNational } from '@/utilities/formatPhoneNumber';

const ContactLine = ({ icon, label, value, display }) => {
    const [copyFeedback, setCopyFeedback] = useState(null);

    const copy = async (event) => {
        event.stopPropagation();
        try {
            await navigator.clipboard.writeText(value);
            setCopyFeedback('Copied!');
        } catch {
            setCopyFeedback('Copy failed');
        }
        setTimeout(() => setCopyFeedback(null), 1500);
    };

    return (
        <Tooltip content={copyFeedback || `Copy ${label}`}>
            <button
                type="button"
                onClick={copy}
                className="group flex min-w-0 max-w-full items-center gap-1.5 text-left text-[12px] text-slate-700 hover:text-slate-900"
            >
                <Icon icon={icon} size="sm" className="size-3 shrink-0 text-slate-400" />
                <span className="truncate">{display}</span>
                <Icon icon={Copy} size="sm" className="size-3 shrink-0 text-slate-300 group-hover:text-slate-500" />
            </button>
        </Tooltip>
    );
};

const ContactCell = ({ row }) => {
    const { email, phone } = row.original;
    if (!email && !phone) {
        return <span className="text-sm text-muted">-</span>;
    }

    // The fallback shows an unparseable phone as stored, not with toNational's "Invalid" suffix.
    const phoneDisplay = toNational(phone, phone);

    return (
        <div className="flex min-w-0 flex-col items-start gap-1">
            {phone ? <ContactLine icon={Phone} label="phone" value={phone} display={phoneDisplay} /> : null}
            {email ? <ContactLine icon={Mail} label="email" value={email} display={email} /> : null}
        </div>
    );
};

export default ContactCell;
